"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const ResetPassword = ({ dispatchCard }) => {
    const [username, setUsername] = (0, react_1.useState)("");
    const [resetMessage, setResetMessage] = (0, react_1.useState)("");
    const [shake, setShake] = (0, react_1.useState)(false);
    const shakeButton = () => {
        setShake(true);
        setTimeout(() => {
            setShake(false);
        }, 300);
    };
    const resetPassword = () => {
        const postData = new FormData();
        postData.append("username", username);
        fetch("user/forgot_password", {
            method: "POST",
            body: postData,
        })
            .then((res) => res.text())
            .then((data) => {
            if (data.trim() != "1") {
                setResetMessage(data);
                shakeButton();
                return;
            }
            setResetMessage("Password reset email sent");
        })
            .catch((err) => console.log(err));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { "data-testid": "reset-password-card-element", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-center", children: "Reset Password" }), (0, jsx_runtime_1.jsx)("p", { className: "login-box-msg", children: resetMessage }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group mb-3", children: [(0, jsx_runtime_1.jsx)("input", { name: "username", type: "text", placeholder: "Your Username", required: true, className: "form-control", value: username, onChange: (e) => setUsername(e.target.value) }), (0, jsx_runtime_1.jsx)("div", { className: "input-group-append", children: (0, jsx_runtime_1.jsx)("div", { className: "input-group-text", children: (0, jsx_runtime_1.jsx)("span", { className: "fa-solid fa-user", style: { color: "#892203" } }) }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "row mb-3", children: (0, jsx_runtime_1.jsx)("div", { className: "col", children: (0, jsx_runtime_1.jsx)("button", { id: "login-btn", type: "submit", className: `btn btn-danger btn-block ${shake ? "shake" : ""}`, onClick: resetPassword, children: "Reset Password" }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "row", children: (0, jsx_runtime_1.jsx)("div", { className: "w-100 mt-2 text-center", children: (0, jsx_runtime_1.jsxs)("a", { style: { color: "#303030", fontSize: "14px" }, type: "button", onClick: () => dispatchCard({ type: "LOGIN" }), "data-testid": "back-to-login-button", children: [(0, jsx_runtime_1.jsx)("i", { className: "fa-solid fa-arrow-left" }), " Back to Login"] }) }) })] }));
};
exports.default = ResetPassword;
